'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getConsoleFunction;
function getConsoleFunction(type) {
  if (typeof console[type] === 'function') {
    return console[type];
  }
  return function () {
    var _console;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (_console = console).log.apply(_console, ['[' + type + ']'].concat(args));
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/jack-logs/util/getConsoleFunction.js
// module id = 1174
// module chunks = 0